import ButtonBack from '@packages/shared/core/common/components/common/ButtonBack';
import Header from '@packages/shared/core/common/components/layout/Header';
import { Expert } from '@packages/shared/core/experts/entities';
import ChatExpert from '../ChatExpert';
import styles from './ChatHeader.module.scss';

type ChatHeaderProps = {
  className?: string;
  onBack: () => void;
  expert: Expert;
};

export const ChatHeader = ({ onBack, expert }: ChatHeaderProps) => {
  return (
    <>
      <div className={styles.headerMobile}>
        <ButtonBack className={styles.back} onClick={onBack} />

        <ChatExpert expert={expert} className={styles.expert} />
      </div>

      <Header className={styles.headerDesktop} menuClassName={styles.menu}>
        <ButtonBack className={styles.back} secondary onClick={onBack} />
      </Header>
    </>
  );
};

export default ChatHeader;
